import { useEffect } from "react";

const syncPerfEvalHeaderHeight = (table) => {
  if (!table) return;

  const row1 = table.querySelector("thead tr:first-child");
  const row2 = table.querySelector("thead tr:nth-child(2)");
  const row3 = table.querySelector("thead tr:nth-child(3)");
  if (!row1) return;

  const row1Height = Math.ceil(row1.getBoundingClientRect().height);
  const row2Height = row2 ? Math.ceil(row2.getBoundingClientRect().height) : 0;
  const row3Height = row3 ? Math.ceil(row3.getBoundingClientRect().height) : 0;

  table.style.setProperty("--perf-eval-thead-row1-height", `${row1Height}px`);
  table.style.setProperty(
    "--perf-eval-thead-row2-top",
    `${row1Height + row2Height}px`,
  );
  table.style.setProperty(
    "--perf-eval-thead-height",
    `${row1Height + row2Height + row3Height}px`,
  );
};

export default function usePerfEvalStickyHeaderHeight(tableRef, deps = []) {
  useEffect(() => {
    const table = tableRef?.current;
    if (!table) return undefined;

    const sync = () => syncPerfEvalHeaderHeight(table);

    sync();

    const resizeObserver =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(sync) : null;

    const thead = table.querySelector("thead");
    const row1 = table.querySelector("thead tr:first-child");
    const row2 = table.querySelector("thead tr:nth-child(2)");

    if (resizeObserver) {
      if (thead) resizeObserver.observe(thead);
      if (row1) resizeObserver.observe(row1);
      if (row2) resizeObserver.observe(row2);
    }

    window.addEventListener("resize", sync);

    let cancelled = false;
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        if (!cancelled) sync();
      });
    }

    return () => {
      cancelled = true;
      resizeObserver?.disconnect();
      window.removeEventListener("resize", sync);
    };
  }, deps);
}
